import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { MetadataDrivenSiteSettings } from '~src/commonInfra/components/MetadataDrivenSiteSetting';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { groupNameMessage } from '../../../../styles/CommonStyles';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';
import { forceUncheckedIfUserVisibilityLimited, useUserVisibilityLimited } from '../user-visibility/UserVisibilitySection';

export const DATA_ALERTS_FIELD = 'settings.dataAlertsEnabled';
export const DATA_ALERTS_SECTION_NAME = 'dataAlertsEnabled';
export const DATA_ALERTS_PREFIX = 'settings';

export type DataAlertsSectionProps = SiteSettingsForSiteAdminProps<'dataAlertsEnabled' | 'userVisibility'>;

export function DataAlertsSection() {
  const isUserVisibilityLimited = useUserVisibilityLimited();

  if (FeatureFlags.metadataDrivenSiteSettingsEnabled) {
    return (
    <SettingsSection
      title={Messages.dataAlertsSiteSettings()}
      testId={'data-alerts-setting-section'}>
        <MetadataDrivenSiteSettings
          sectionName={DATA_ALERTS_SECTION_NAME}
          formikPrefix={DATA_ALERTS_PREFIX} />
    </SettingsSection>
    );
  }

  return FeatureFlags.alertOnThresholdConditionEnabled
    ? (
      <SettingsSection title={renderTitle(isUserVisibilityLimited)}
                       testId={'data-alerts-setting-section'}
                       description={Messages.dataAlertsSiteSettingsDetails()}
                       disabled={isUserVisibilityLimited}>
        <FormikCheckbox
                        name={DATA_ALERTS_FIELD}
                        label={Messages.dataAlertsSiteSettingsEnable()}
                        testId={'data-alerts-enabled'}
                        disabled={isUserVisibilityLimited}
                        {...forceUncheckedIfUserVisibilityLimited(isUserVisibilityLimited)}
        />
      </SettingsSection>
    )
    : null;
}

function renderTitle(isUserVisibilityLimited: boolean) {
  return <>
    <div>{Messages.dataAlertsSiteSettings()}</div>
    {isUserVisibilityLimited &&
    <span className={groupNameMessage} data-tb-test-id={'dataalerts-uservisibility-warning'}>
      {Messages.userVisibilityWarning()}
    </span>}
  </>;
}

export const DataAlertsSectionSpecs = componentRegistryEntry({
  name: 'DataAlertsSection',
  component: DataAlertsSection
});
